import React, { Table } from 'tea-component';
import SvgIcon from '@gp/components/Iconfont';
import GeneralImageNew from '@gp/components/GeneralImageNew';
//@ts-ignore
import * as rbd from 'react-beautiful-dnd';
//@ts-ignore
import style from '../../index.module.scss';
import DEFAULT_COUNTRY_ICON from '@gp/assets/svg/flag-default.svg';

const { selectable, draggable, removeable, scrollable, autotip } = Table.addons;


interface Props {
  dataSource: any;
  onDragEnd: (records: any, context: any) => void;
  onRemove: (key: any) => void;
  allCountryFlag:{[key in string]: string }
}

export default function  TargetTable(props: Props) {
  const { dataSource, onDragEnd, onRemove ,allCountryFlag } = props;
  // 右侧表格配置
const RIGHT_COLUMNS = [
  {
    key: "game",
    render: cvm => {
      return (
        <div className='dbg-similar-modal-table'>
            <GeneralImageNew
              className="dbg-similar-modal-table-img"
              domain="game"
              width={36}
              height={36}
              src={cvm?.cover}
            />
        <div className='dbg-similar-modal-table-context'>
            <div className='dbg-similar-modal-table-name'>{cvm.entity_name}</div>
            <div className='dbg-similar-modal-table-massage'>
                <span  className='dbg-similar-modal-table-icon'><SvgIcon type={cvm.entity_type} /></span>
                {/* <SvgIcon type={cvm.entity_type} /> */}
                <img className="dbg-similar-modal-table-countryicon"
                  src={allCountryFlag[cvm?.country_en_name_abbr] || DEFAULT_COUNTRY_ICON}
                  onError={(e) => {
                    e.target.src = DEFAULT_COUNTRY_ICON;
                  }}
                 />
                <span className='dbg-similar-modal-table-text'>{cvm.publisher}</span>
            </div>
        </div>
    </div>
      )
    }
},
];
  return (
    <Table
      records={dataSource}
      className={`${dataSource?.length == 0 ? 'is-no-data' : ''}`}
      recordKey="game_id"
      columns={RIGHT_COLUMNS}
      hideHeader
      addons={[
        // scrollable({
        //   virtualizedOptions: {
        //     height: 339,
        //     itemHeight: 64,
        //   },
        // }),
        removeable({ onRemove }),
        autotip({
          className: 'dbg-add-entities-table-autotip',
          emptyText: 'Please select any Game first',
        }),
        draggable({
          module: rbd,
          onDragEnd,
        }),
      ]}
      // topTip={
      //     dataSource?.length == 0 && (
      //         <StatusTip
      //             // @ts-ignore
      //             status={'empty'}
      //         />
      //     )
      // }
    />
  );
}
